import { Tag } from "antd";
import { NumericDigits } from "../shared/constants";

const hrnUtils = {
  badge: (value: number) => (
    <Tag className="bg-[#808080] text-white rounded-full mr-0">{value}</Tag>
  ),

  tag: (value: string | number, type: "ACTIVE" | "INACTIVE" = "ACTIVE") => {
    return (
      <Tag
        className={`${type === "ACTIVE" ? "bg-sea-green" : "bg-sonic-silver"
          } text-white font-medium px-3 rounded-full`}
      >
        {value}
      </Tag>
    );
  },
  dropdownFilterOption: (input: any, option: any) => ((option?.label as string) ?? "").toLowerCase().includes(input?.toLowerCase() ?? ""),
  groupBy: (array: Array<any>, prop: string) => {
    return array.reduce((item, x) => {
      (item[x[prop]] = item[x[prop]] || []).push(x);
      return item;
    }, {});
  },
  getNumberInEnglish: (number: string | number) => {
    if (typeof (number) !== "string") number = number.toString();
    return number.split("").map(d => {
      let index = NumericDigits["en"].findIndex((x: string) => x === d);
      if (index >= 0) return d;
      index = NumericDigits["ar"].findIndex((x: string) => x === d);
      if (index >= 0) return NumericDigits["en"][index];
      index = NumericDigits["bn"].findIndex((x: string) => x === d);
      if (index >= 0) return NumericDigits["en"][index];
      return "";
    }).join("")
  },
  getNumberInLanguage: (number: string | number, language: string) => {
    if (typeof (number) !== "string") number = number.toString();
    return number.split("").map(d => {
      let index = NumericDigits["en"].findIndex((x: string) => x === d);
      if (index >= 0) return NumericDigits[language]?.[index] || d;
      index = NumericDigits["ar"].findIndex((x: string) => x === d);
      if (index >= 0) return NumericDigits[language]?.[index] || d;
      index = NumericDigits["bn"].findIndex((x: string) => x === d);
      if (index >= 0) return NumericDigits[language]?.[index] || d;
      return "";
    }).join("")
  },
  handleNumberFieldKeyPressEvent: (e: any, options?: { noOfDigitsAllowed?: number, decimal?: boolean, allowNegative?: boolean }) => {
    if (!options) options = {};
    if (!options.decimal && (e.key === "e" || e.key === "E" || e.key === ".")) {
      e.preventDefault(); // Prevent the key press
    }
    if (!options.allowNegative && e.key === "-") {
      e.preventDefault(); // Prevent the key press
    }
    if (!options.noOfDigitsAllowed) options.noOfDigitsAllowed = 4;
    const currentValue = e.target.value;
    // Check if the current input value is more than 4 digits
    if (currentValue.length >= options.noOfDigitsAllowed && !["Backspace", "Delete"].includes(e.key)) {
      e.preventDefault(); // Prevent the key press
    }
  },
  handleMobileNumberFieldKeyDownEvent: (e: any) => {
    if (!(e.key >= "0" && e.key <= "9") && e.key !== "+" && e.key !== "-" && e.key !== "Backspace" && e.key !== "Delete" && !e.key.startsWith("Arrow") && e.key !== "Space" && e.key !== " ")
      e.preventDefault();
  },
  handleDateFieldKeyDownEvent: (e: any) => {
    if (!(e.key >= "0" && e.key <= "9") && e.key !== "/" && e.key !== "-" && e.key !== "Backspace" && e.key !== "Delete" && !e.key.startsWith("Arrow"))
      e.preventDefault();
  }
};

export default hrnUtils;
